import React, { useEffect, useState } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Home from './pages/Home';
import AdminLogin from './pages/AdminLogin';
import Admin from './pages/Admin';
import Blog from './pages/Blog';
import Article from './pages/Article';
import CustomCursor from './components/CustomCursor';
import Splash from './components/Splash';
import ScrollProgress from './components/ScrollProgress';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';

function useReveal() {
  useEffect(() => {
    const observe = () => {
      const els = document.querySelectorAll('.reveal:not(.is-visible)');
      els.forEach((el) => io.observe(el));
    };
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            e.target.classList.add('is-visible');
            io.unobserve(e.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -40px 0px' }
    );
    observe();
    const t = setInterval(observe, 800);
    return () => { io.disconnect(); clearInterval(t); };
  }, []);
}

function useHideEmergentBadge() {
  useEffect(() => {
    const hide = () => {
      try {
        const badge = document.getElementById('emergent-badge');
        if (badge) {
          badge.style.display = 'none';
          badge.style.visibility = 'hidden';
          badge.style.pointerEvents = 'none';
        }
        document.querySelectorAll('a[href*="emergent.sh"]').forEach((el) => {
          const style = window.getComputedStyle(el);
          if (style.position === 'fixed') {
            el.style.display = 'none';
            el.style.visibility = 'hidden';
            el.style.pointerEvents = 'none';
          }
        });
      } catch (e) { /* noop */ }
    };
    hide();
    const observer = new MutationObserver(hide);
    observer.observe(document.body, { childList: true, subtree: true });
    const interval = setInterval(hide, 1500);
    return () => { observer.disconnect(); clearInterval(interval); };
  }, []);
}

function Shell({ children }) {
  useReveal();
  return children;
}

function App() {
  const [showSplash, setShowSplash] = useState(true);
  useHideEmergentBadge();

  useEffect(() => {
    const seen = sessionStorage.getItem('thesis_splash');
    if (seen) setShowSplash(false);
    else {
      sessionStorage.setItem('thesis_splash', '1');
      const t = setTimeout(() => setShowSplash(false), 2400);
      return () => clearTimeout(t);
    }
  }, []);

  return (
    <div className="App">
      <ScrollProgress />
      <CustomCursor />
      {showSplash && <Splash />}
      <BrowserRouter>
        <AuthProvider>
          <Routes>
            <Route path="/" element={<Shell><Home /></Shell>} />
            <Route path="/blog" element={<Shell><Blog /></Shell>} />
            <Route path="/blog/:slug" element={<Shell><Article /></Shell>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<Admin />} />
            <Route path="*" element={<Navigate to="/" />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors theme="dark" />
    </div>
  );
}

export default App;
